import firebase from 'firebase/compat/app';

async function buildHeaders(existingHeaders = {}) {
    const user = firebase.auth().currentUser;
    const token = user ? await user.getIdToken() : null;
    return {
        ...existingHeaders,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

export async function fetchWithAuth(url, options = {}) {
    const headers = await buildHeaders(options.headers);
    const res = await fetch(url, { ...options, headers });

    if (res.status === 401) {
        const user = firebase.auth().currentUser;
        if (user) {
            const freshToken = await user.getIdToken(true);
            const retryRes = await fetch(url, {
                ...options,
                headers: { ...options.headers, Authorization: `Bearer ${freshToken}` },
            });
            if (retryRes.status !== 401) return retryRes;
        }
        await firebase.auth().signOut();
        throw new Error('Session expired. Please sign in again.');
    }

    return res;
}
